<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl ? `master/academic-calendar-detail/${inputs.id}` : `master/academic-calendar-detail`
				"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_academic_calendar_name" class="col-sm-3 mb-0">
						Academic Calendar Name
					</label>
					<app-input
						id="inputs_academic_calendar_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.academic_calendar_name"
						:placeholder="'Academic Calendar Name'"
						:required="true"
                        disabled
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_date" class="col-sm-3 mb-0">
						Date
					</label>
					<app-input
						id="inputs_date"
						class="col-sm-9"
						type="date"
						v-model="inputs.date"
						:placeholder="'Date'"
						:required="true"
					/>
				</div>

                <!-- Description -->
				<div class="form-group row align-items-center">
					<label for="inputs_description" class="col-sm-3 mb-0">
						Description
					</label>
					<app-input
						id="inputs_description"
						class="col-sm-9"
						type="textarea"
						v-model="inputs.description"
						:placeholder="'Description'"
					/>
				</div>

                 <!-- CLC Date -->
				<div class="form-group row align-items-center">
					<label for="inputs_clc_date" class="col-sm-3 mb-0">
						CLC Date
					</label>
					<app-input
						id="inputs_clc_date"
						class="col-sm-9"
						type="textarea"
						v-model="inputs.clc_date"
						:placeholder="'CLC Date'"
					/>
				</div>

                <div class="form-group row align-items-center">
					<label for="inputs_is_holiday" class="col-sm-3 mb-0">
						&nbsp;
					</label>
					<div class="col-sm-8">
						<app-input
							id="inputs_is_holiday"
							:list-value-field="'Is Holiday'"
							type="single-checkbox"
							v-model="inputs.is_holiday"
						/>
					</div>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_is_active" class="col-sm-3 mb-0">
						&nbsp;
					</label>
					<div class="col-sm-8">
						<app-input
							id="inputs_is_active"
							:list-value-field="$t('is_active')"
							type="single-checkbox"
							v-model="inputs.is_active"
						/>
					</div>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
export default {
	name: "ModalFormDetail",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		clcCalendarRowData: {
            type: Object,
            default: () => {
                return {}
            }
        }
	},
	data() {
		return {
			preloader: false,
			inputs: {
			},
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		} else {
			this.academic_calendar_id = this.clcCalendarRowData.id;
			this.inputs.academic_calendar_name = this.clcCalendarRowData.academic_calendar_name;
		}
	},
	methods: {
		submit() {
			if (this.selectedUrl) {
				this.inputs.created_at = this.formattedDate(this.inputs.created_at);
				this.inputs.updated_at = this.formattedDate(this.inputs.updated_at);
			}
			this.inputs.date = this.formattedDate(this.inputs.date);
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.inputs.academic_calendar_name = response.data.academic_calendar_id.academic_calendar_name;
			this.inputs.academic_calendar_id = response.data.academic_calendar_id.id;
			this.preloader = false;
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
	},
};
</script>
